export const GetStoredAPIs = (builder) => ({
  GetStoredAPIs: builder.mutation({
    query: ({ page, limit, search, sortBy, sortOrder }) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/api_integrations",
        method: "GET",
        params: { page, limit, search, sortBy, sortOrder },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
    },
  }),
});
